import React from 'react';
import {connect} from 'react-redux';

import {AppState} from "@Redux/store";
import {Dispatch} from "@Redux/type";
import NinthAgeUnitV2MakeForm from "./NinthAgeUnitV2MakeForm";
import {NinthAgeUnitV2MakeParams} from "./NinthAgeUnitV2MakeValidate";
import {container} from "@Container";
import {TYPES} from "@Types";
import {SurveyAction} from "@Redux/actions/tool/survey/SurveyAction";

const NinthAgeUnitV2Make: React.FC<NinthAgeUnitV2MakeProps> = ({handleSubmit}) => {
  React.useEffect(() => {
  }, []);

  return (
    <NinthAgeUnitV2MakeForm onSubmit={handleSubmit}/>
  );
};

const mapStateToProps = (state: AppState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const surveyAction = container.get<SurveyAction>(TYPES.Actions.Tool.Survey.SurveyAction)
  return {
    handleSubmit: (values: NinthAgeUnitV2MakeParams) => dispatch(surveyAction.saveUnit(values)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NinthAgeUnitV2Make);

type NinthAgeUnitV2MakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
